export default {
  'Super Admin': '/command',
  'VIP': '/home',
  'Coordinator': '/my-kps',
  'KP': '/my-tasks',
  'Member': '/assigned-tasks',
  'Leg Support': '/legislators',
}
